/**
 * Which assessments the start modal may offer to retake.
 *
 * "Retake" only makes sense for an attempt that exists — completed, or started
 * and abandoned. A NOT_STARTED assessment is taken, not retaken, and it reaches
 * the student through the pre-assessment gate rather than through this link.
 */

import { ASSESSMENT_ATTEMPT_STATUS } from "@/types/assessmentAttemptStatus";

export interface RetakeAssessmentItem {
  type: "exit_ticket" | "pre_assessment";
  label: string;
}

export interface RetakeAssessmentInput {
  hasExitTicket?: boolean;
  exitTicketState?: string | null;
  hasPreAssessment?: boolean;
  preAssessmentState?: string | null;
}

const isRetakeable = (state: string | null | undefined): boolean =>
  state === ASSESSMENT_ATTEMPT_STATUS.COMPLETED ||
  state === ASSESSMENT_ATTEMPT_STATUS.IN_PROGRESS;

export const resolveRetakeAssessments = ({
  hasExitTicket,
  exitTicketState,
  hasPreAssessment,
  preAssessmentState,
}: RetakeAssessmentInput): RetakeAssessmentItem[] => {
  const items: RetakeAssessmentItem[] = [];
  if (hasExitTicket && isRetakeable(exitTicketState)) {
    items.push({ type: "exit_ticket", label: "Exit Ticket" });
  }
  if (hasPreAssessment && isRetakeable(preAssessmentState)) {
    items.push({ type: "pre_assessment", label: "Pre-Assessment" });
  }
  return items;
};
